import { render, staticRenderFns } from "./ItemsTableComponent.vue?vue&type=template&id=236c18f6&"
import script from "./ItemsTableComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports